import { NARRATIVE_CARD_FRAGMENT } from '@/components/NarrativeCard';
import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query CommunityUser($displayName: String!) {
    communityUser(displayName: $displayName) {
      displayName
      imageUrl
      name
      role
      url
      narratives {
        ...NarrativeCardFields
      }
    }
  }
`,
  [NARRATIVE_CARD_FRAGMENT]
);

export const useCommunityUser = makeGqlSuspenseQuery(QUERY, {
  tags: ['narrative', 'narrative-user-list'],
});
